import { InvitationsTable } from '@/components/invitations';
import { PageHeader } from '@/components/ui';
import { usePageTitleStore } from '@/stores/page-title';
import { Container } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Affiliate invitations list — its own route now that the Affiliates page no
 * longer carries a tab bar. Reached from the sidebar's Affiliation group.
 */
const AffiliateInvitationsPage = () => {
  const { t } = useTranslation();
  const setTitle = usePageTitleStore((state) => state.setTitle);

  useEffect(() => {
    setTitle(t('invitations.title'));
    return () => setTitle(null);
  }, [setTitle, t]);

  return (
    <Container maxW="full" py={{ base: 5, xl: 6 }} px={{ base: 4, xl: 6 }}>
      <PageHeader title={t('invitations.title')} description={t('invitations.description')} />
      <InvitationsTable />
    </Container>
  );
};

export default AffiliateInvitationsPage;
